document.addEventListener('DOMContentLoaded', () => {
    if (typeof intlTelInput !== 'undefined') {
        const inputs = document.querySelectorAll('[name="billing_phone"]');

        let initCountry = '';
        const restricted_countries = JSON.parse(document.querySelector('[name="restricted_countries"]').value);

        if (document.querySelector('[name="billing_country"]')) {
            initCountry = document.querySelector('[name="billing_country"]').value.toLowerCase();
        }

        inputs.forEach(input => {
            if (input) {
                if (input.getAttribute('data-init-country')) {
                    initCountry = input.getAttribute('data-init-country').toLowerCase();
                }

                intlTelInput(input, {
                    initialCountry: initCountry ? initCountry : '',
                    excludeCountries: restricted_countries,
                    utilsScript: "/wp-content/themes/ecommerce/src/css/modules/intl/js/utils.js",
                });
            }
        });
    }
});